// extracted by mini-css-extract-plugin
export default {"status-header":"StatusHeader_status-header__lbKNt","status-header__arrow":"StatusHeader_status-header__arrow__rHDfd","item-lastest":"StatusHeader_item-lastest__8BbPs"};